import FinancingType from '~/constants/FinancingType';
import { useFinanceType } from '~/contexts/FinanceAndTradeContext';
import Pricing from './Pricing/Pricing';
import Terms from './Terms/Terms';
import UnlockPayment from './Terms/UnlockPayment';

export default function PricingAndTerms() {
  const showTerms = useFinanceType() === FinancingType.UserFinancing;

  return (
    <div className="flex flex-row justify-between">
      <Pricing />
      {showTerms ? <Terms /> : <UnlockPayment />}
    </div>
  );
}
